import { EventDetailsTab } from 'types';

export const EVENT_DETAILS_TAB_INDEX: Record<EventDetailsTab, number> = {
  [EventDetailsTab.EVENT]: 0,
  [EventDetailsTab.PARTICIPANTS]: 1,
  [EventDetailsTab.TASKS]: 2,
  [EventDetailsTab.DOCUMENTATION]: 3,
};

export const getEventDetailsTabIndex = (tab?: EventDetailsTab): number => {
  if (!tab) {
    return EVENT_DETAILS_TAB_INDEX[EventDetailsTab.EVENT];
  }

  return (
    EVENT_DETAILS_TAB_INDEX[tab] ??
    EVENT_DETAILS_TAB_INDEX[EventDetailsTab.EVENT]
  );
};
